import { Component, inject, OnInit } from '@angular/core';
import { PortalTheme } from '@app/@shared/models';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';
import { ReportsTableComponent } from '@app/areas/reports/components';

@Component({
  standalone: true,
  template: '<app-reports-table [theme]="theme"/>',
  styleUrls: ['./reports.component.scss'],
  imports: [ReportsTableComponent],
})
export class ReportsComponent implements OnInit {
  protected theme!: PortalTheme;
  private readonly applicationProfileService = inject(ApplicationProfileService);

  ngOnInit(): void {
    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      this.theme = profile.PortalTheme.Theme;
    });
  }
}
